export class FacilityFixed {
  constructor() {
    const items = document.querySelectorAll('.js-facility_item')
    const layers = document.querySelectorAll('.js-facility_layer')

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id')
            layers.forEach((link) => {
              link.classList.toggle('is-act', link.dataset.target === id)
            })
          }
        })
      },
      {
        root: null,
        rootMargin: '0px 0px -50% 0px',
        threshold: 0,
      },
    )

    items.forEach((section) => {
      observer.observe(section)
    })
  }
}
